import React, { useState, useEffect, useContext, useRef } from "react";
// import all components
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  Typography,
  Container,
  Button,
  Grid,
  Paper,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

// import all icons
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import TuneIcon from "@mui/icons-material/Tune";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

// import all custom components
import auditData from "../../mockData/revisedAuditData.json";
import RevisedGameContentBlock from "./RevisedGameContentBlock";
import { getBlobsList } from "../../services/AzureGameAudit.Service";
import { GameAuditBlobsService } from "../../services/GameAudit.Service";
import AuditFilterTabList from "./AuditFilterTabList";
import { AppDataContext } from "../../common/appContext";
import AuditVideoListSlider from "./AuditVideoListSlider";
import moment from "moment";
import { UserDataService } from "../../services";

// import slick carousel css
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const useStyles = makeStyles((theme) => ({
  slickSliderContainer: {
    margin: theme.spacing(2, 0),
  },
  auditFilterBtn: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "flex-end",
  },
  drawerBoxContainer: {
    display: "flex",
    direction: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.5rem",
  },
}));

const RevisedGameAuditContainer = () => {
  const classes = useStyles();
  const [auditVideoList, setAuditVideoList] = useState([]);
  const [filteredAuditVideoList, setFilteredAuditVideoList] = useState([]);
  const [currentPlay, setCurrentPlay] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [strengthAndAgility, setStrengthAndAgility] = useState([
    "Shuttle Run",
    "Pro Lane",
    "3/4 Run",
    "Max Vert",
    "No Step Vertical",
  ]);
  const [shooting, setShooting] = useState([
    "Spot Up",
    "Mid Side Mid",
    "Side Mid Side",
    "Off the Dribble",
    "Free Throws",
    "Mid Range Star Drill",
    "3-Point Star",
  ]);
  const [ballHandling, setBallHandling] = useState(["Ball Handling"]);
  const [situationalWorkOuts, setSituationalWorkOuts] = useState([
    "Contested Shooting",
    "4 vs 4 Half Court",
    "3-2 | 2-1 | 1-1",
  ]);
  const { selectedEventId, user } = useContext(AppDataContext);
  const [isAuditDrawerOpen, setIsAuditDrawerOpen] = useState(false);
  const [filterSelection, setFilterSelection] = useState({ arrayvar: ["All"] });
  const lastModifiedDateRef = useRef(null);
  const [refreshTokenTime, setRefreshTokenTime] = useState("30000");

  function convertTZ(date, tzString) {
    return new Date(
      (typeof date === "string" ? new Date(date) : date).toLocaleString(
        "en-US",
        { timeZone: tzString }
      )
    );
  }

  useEffect(() => {
    const getGameAuditRefreshTime = async () => {
      await UserDataService.getGameAuditRefreshTimeToken().then((res) => {
        if (res.data) {
          const { childName } = res.data[0];
          setRefreshTokenTime(childName);
        }
      });
    };
    getGameAuditRefreshTime();
  }, []);

  const fetchAllData = async () => {
    try {
      setLoading(true);
      // await getBlobsList().then((data) => {
      //   data.sort(function (a, b) {
      //     // Turn your strings into dates, and then subtract them
      //     // to get a value that is either negative, positive, or zero.
      //     return new Date(b.createdDate) - new Date(a.createdDate);
      //   });

      //   const filterOptions = [...new Set(data.map((list) => list.drillType))];
      //   setAuditVideoList(data);
      //   setFilteredAuditVideoList(data);
      //   setFilterTabList(filterOptions);
      //   setLoading(false);
      // });

      //!Second method
      const returnedBlobUrls = [];
      await GameAuditBlobsService.getGameAuditBlobsData(
        selectedEventId,
        lastModifiedDateRef.current
      ).then((response) => {
        //!Update last modified Date timestamp.
        lastModifiedDateRef.current = moment(
          convertTZ(new Date(), "America/New_York")
        ).format("YYYY-MM-DD HH:mm:ss");

        //!If data found format it into required.
        if (response?.data?.length > 0) {
          response.data.forEach((blob) => {
            returnedBlobUrls.push({
              videoUrl: `${blob.fileName}`,
              drillType: blob.drillType ?? "####",
              playerName: blob.playerName ?? "####",
              createdDate: blob.createdDate,
              playerId: blob.playerId,
              eventId: blob.eventId,
              stationId: blob.stationId,
              thumbnail: blob.thumbnail,
            });
          });
        }

        //!If blobs found update respective states.
        if (returnedBlobUrls.length > 0) {
          setAuditVideoList((prev) => {
            return [...prev, ...returnedBlobUrls].sort(
              (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
            );
          });
          setFilteredAuditVideoList((prev) => {
            return [...prev, ...returnedBlobUrls].sort(
              (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
            );
          });
        }
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  //!It will runs every 30sec to update the video list
  useEffect(() => {
    const intervalCall = setInterval(() => {
      //fetchAllData();
      setSearchText("");
    }, refreshTokenTime);

    return () => {
      // clean up
      clearInterval(intervalCall);
    };
  }, []);

  //!It will runs first time to update the video list
  // useEffect(() => {
  //   fetchAllData();
  //   setSearchText("");
  // }, []);

  useEffect(() => {
    //Clear everything again and then fetch data.
    setAuditVideoList([]);
    setFilteredAuditVideoList([]);
    setCurrentPlay({});
    setSearchText("");
    lastModifiedDateRef.current = "null";

    //fetchAllData();
  }, [selectedEventId]);

  // useEffect(() => {
  //   if (auditVideoList.length > 0 && JSON.stringify(currentPlay) === "{}") {
  //     setCurrentPlay(auditVideoList[0]);
  //   }
  // }, [auditVideoList]);

  useEffect(() => {
    //Filter the audit list based on search parameter and for all drills.
    if (filterSelection.arrayvar[0] === "All") {
      if (searchText === "") {
        setFilteredAuditVideoList(auditVideoList);
        return;
      }

      const filterData = auditVideoList.filter((list) =>
        list.playerName.toLowerCase().includes(searchText.toLowerCase())
      );

      setFilteredAuditVideoList(filterData);
      return;
    }

    //Filter the audit list based on search parameter and selected drills.
    const filterData = auditVideoList.filter((list) => {
      if (searchText !== "") {
        return (
          filterSelection.arrayvar.includes(list.drillType) &&
          list.playerName.toLowerCase().includes(searchText.toLowerCase())
        );
      } else {
        return filterSelection.arrayvar.includes(list.drillType);
      }
    });
    setFilteredAuditVideoList(filterData);
  }, [filterSelection, searchText]);

  const handleVideoSelect = (videoInfo) => {
    setCurrentPlay(videoInfo);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const onSearchClick = () => {};

  const clearAuditFilter = () => {
    setSearchText("");
    setFilterSelection({ arrayvar: ["All"] });
  };

  const handaleFilterSelection = (value) => {
    //If selected filter value for all type directly update respective state values.
    if (value === "All") {
      setFilterSelection({ arrayvar: [value] });
    } else {
      //If selected filter value already exist in state remove it! & update respective state values.
      if (filterSelection.arrayvar.includes(value)) {
        const newDataArr = filterSelection.arrayvar.filter(
          (item) => item !== value
        );

        if (newDataArr.length === 0) {
          setFilterSelection({ arrayvar: ["All"] });
        } else {
          setFilterSelection({
            arrayvar: newDataArr.filter((item) => item !== "All"),
          });
        }
      } else {
        //If selected filter value not already exist in state add it! & update respective state values.
        setFilterSelection((prevState) => ({
          arrayvar: [
            ...prevState.arrayvar.filter((item) => item !== "All"),
            value,
          ],
        }));
      }
    }
  };

  const handleDeleteFilterSelection = (value) => {
    handaleFilterSelection(value);
  };

  const handleRefreshPage = () => {
    window.location.reload(false);
  };

  return (
    <>
      <Box>
        <CssBaseline />
        {/*Appbar Start*/}
        <Paper elevation={4}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ marginBottom: "10px", padding: "0.5rem" }}
          >
            <Grid item>
              <Box ml={5} alignItems="center">
                <Typography variant="h6" noWrap component="div">
                  Videos Dashboard
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box
                component="div"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <IconButton
                  aria-label="Refresh"
                  sx={{ marginLeft: "5px" }}
                  title="Refresh"
                  onClick={handleRefreshPage}
                >
                  <RestartAltIcon size="small" color="secondary" />
                </IconButton>
                <FormControl
                  sx={{
                    width: "35ch",
                  }}
                  variant="outlined"
                  size="small"
                >
                  <InputLabel htmlFor="outlined-adornment-password">
                    Search player
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type="text"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        {searchText !== "" && (
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClearSearch}
                            edge="end"
                          >
                            <ClearIcon color="secondary" />
                          </IconButton>
                        )}
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={onSearchClick}
                          edge="end"
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Search User"
                  />
                </FormControl>
                <Button
                  endIcon={<TuneIcon />}
                  className={classes.auditFilterBtn}
                  onClick={() => setIsAuditDrawerOpen(true)}
                >
                  FILTER
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {/* Main Game Audit Container section */}
        <Container maxWidth={false}>
          <Box component="main">
            <RevisedGameContentBlock data={currentPlay} />

            <Box className={classes.slickSliderContainer}>
              <AuditVideoListSlider
                activeVideo={currentPlay}
                auditVideoList={filteredAuditVideoList}
                handleVideoSelect={handleVideoSelect}
                loading={loading}
              />
            </Box>
          </Box>

          <Drawer
            anchor="right"
            open={isAuditDrawerOpen}
            onClose={() => setIsAuditDrawerOpen(false)}
          >
            <Box className={classes.drawerBoxContainer}>
              <CloseIcon
                display="flex"
                justifyContent="flex-end"
                onClick={() => setIsAuditDrawerOpen(false)}
                fontSize="12px"
                alignItems="center"
              />
              {/* <Button
                variant="outlined"
                onClick={clearAuditFilter}
                size="small"
              >
                Reset
              </Button> */}
            </Box>
            <AuditFilterTabList
              strengthAndAgility={strengthAndAgility}
              shooting={shooting}
              ballHandling={ballHandling}
              situationalWorkOuts={situationalWorkOuts}
              handaleFilterSelection={handaleFilterSelection}
              filterSelection={filterSelection}
              handleDeleteFilterSelection={handleDeleteFilterSelection}
            />
          </Drawer>
        </Container>
      </Box>
    </>
  );
};

export default RevisedGameAuditContainer;
